import { NgModule } from '@angular/core';
import { IsTruncatedByCssPipe } from '~app/modules/account/modules/orders-history/pipes/is-trancated.pipe';

@NgModule({

  declarations: [
    IsTruncatedByCssPipe,
  ],
  exports: [
    IsTruncatedByCssPipe
  ]
})

export class PipesModule {}
